import React from "react";
import NFLookupEmptyForms from "../../../../Shared/NewForms/NFLookupEmptyForms";

function ConsumptionOrdersGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default ConsumptionOrdersGenericSkeleton;
